import React, { VoidFunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { FormGroup } from 'record-it-components/form/FormGroup/FormGroup';
import { BufferedTextInput } from 'record-it-components/input/TextInput/TextInput';
import {
  SingleTabEditDialog,
  SingleTabEditDialogProps
} from 'record-it-components/modal/SingleTabEditDialog/SingleTabEditDialog';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { EntityName } from 'record-it-time-common/EntityName';
import { UserGroup } from '../../../classes/entities/UserGroup/userGroupTypes';
import { useEntityPropertyChangedCallback } from '../../../hooks/entity/useEntityPropertyChangedCallback';
import { useModifyEntityCallback } from '../../../hooks/entity/useModifyEntityCallback';
import { UserGroupToUsersWidget } from '../UserGroupToUsersWidget/UserGroupToUsersWidget';

export type EditUserGroupDialogProps = PropsWithoutChildren<
  Omit<SingleTabEditDialogProps, 'tabTitle'>
> & {
  userGroup: UserGroup;
};

export const EditUserGroupDialog: VoidFunctionComponent<EditUserGroupDialogProps> =
  React.memo((props) => {
    const { userGroup, ...remainingProps } = prepareProps({
      props,
      ignoreChildren: true
    });

    const { t } = useTranslation();

    const handleUserGroupChanged = useModifyEntityCallback(
      EntityName.UserGroup
    );
    const handleNameChanged = useEntityPropertyChangedCallback(
      userGroup,
      'name',
      handleUserGroupChanged
    );

    return (
      <SingleTabEditDialog
        tabTitle={t('components.userGroup.EditUserGroupDialog.title')}
        {...remainingProps}
      >
        <FormGroup>
          <BufferedTextInput
            label={t('entities.UserGroup.name')}
            value={userGroup.name}
            onInput={handleNameChanged}
          ></BufferedTextInput>
        </FormGroup>
        <FormGroup>
          <UserGroupToUsersWidget
            userGroup={userGroup}
          ></UserGroupToUsersWidget>
        </FormGroup>
      </SingleTabEditDialog>
    );
  });
